import axiosInstance from "../server/axios"

export const fatchOffers=(search,limit,page,typeId)=>{
    return axiosInstance.get(`/offres`, {
      params: { search, page, limit,type_id:typeId },
      headers: {
        'Content-Type': 'application/json',
      },
    });
}
export const fatchOffersByType=(typeId)=>{
    const token=localStorage.getItem('authToken')
    const role=localStorage.getItem('role') ==  'superadmin' 
    return axiosInstance.get(`/getOffersByType/${typeId}?off=${role}`, {
      
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },

    });
}



export const getAllTypeOffers=(search,limit,page)=>{
  const token=localStorage.getItem('authToken')
    return axiosInstance.get(`/getAllTypeOffers`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
    });
}

export const addOffer = (data) => {
    const token=localStorage.getItem('authToken')
    const adminId=localStorage.getItem('adminId')
    return axiosInstance.post(`/offres`, { ...data, admin_id: adminId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
    });
};

export const editOffer = (id, data) => {
    const token = localStorage.getItem('authToken');
    return axiosInstance.put(`/offres/${id}`, data, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
    });
};

export const deleteOffer = (id) => {
    const token = localStorage.getItem('authToken');
    return axiosInstance.delete(`/offres/${id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
};

export const getOfferById = (id) => {
    const token = localStorage.getItem('authToken');
    return axiosInstance.get(`/offres/${id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
};
export const  newGetOfferById = (id) => {
    const token = localStorage.getItem('authToken');
    return axiosInstance.get(`/newoffershow/${id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
};

